import styled from 'styled-components/macro';

export const ModalWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  padding: 100px 80px 0 80px;
  max-width: 1200px;
  justify-content: space-between;
  position: relative;
`;

export const RemoveButtonWrapper = styled('div')`
  position: absolute;
  top: 20px;
  right: 10px;
  transform: scale(2);

  svg {
    cursor: pointer;
  }
`;
